/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'close-other': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M828.325 194.495c-175.027-175.029-458.804-175.029-633.83 0-175.028 175.027-175.028 458.803 0 633.831 175.028 175.028 458.803 175.027 633.83 0s175.027-458.804 0-633.831zm-318 344.773L262.147 787.444l-28.943-28.943L481.38 510.325 233.204 262.148l28.943-28.944 248.177 248.177 248.178-248.177 28.943 28.944-248.177 248.177L787.444 758.5 758.5 787.444 510.324 539.268z"/>'
  }
})
